import { useEffect, useState, useRef, useDeferredValue } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { editProvider, fetchProviders, removeProvider } from 'modules/categories/categoriesSlice';
// eslint-disable-next-line max-len
import PharmaciesProvidersComponent from 'modules/categories/pharmacies/components/PharmaciesProvidersComponent';
import { searchQueryMinLength, status } from 'constants/general';
import { useParams } from 'react-router-dom';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const PharmaciesProvidersContainer = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();
  const { priceListId } = useParams();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [searchQuery, setSearchQuery] = useState('');
  const InitialQueryString = {
    priceListId,
    pageNumber: 1,
    pagesize: 10,
  };
  const [providersQueryString, setProvidersQueryString] = useState(InitialQueryString);
  const [isCreateProviderModalHidden, setIsCreateProviderModalHidden] = useState(true);
  const [isDoctorInfoModalHidden, setDoctorInfoModalModalHidden] = useState(true);
  const [filtersSelected, setFiltersSelected] = useState([]);

  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  const submitProvidersBulkState = useSelector(state => state.categories.submitProvidersBulk);
  const removeProviderState = useSelector(state => state.categories.removeProvider);
  const editProviderState = useSelector(state => state.categories.editProvider);

  const prevSubmitProvidersBulk = useDeferredValue(submitProvidersBulkState.status);
  const prevRemoveProviderState = useDeferredValue(removeProviderState.status);
  const prevEditProviderState = useDeferredValue(editProviderState.status);
  useEffect(() => {
    if (
      (status.SUCCESS === submitProvidersBulkState.status &&
        prevSubmitProvidersBulk !== submitProvidersBulkState.status) ||
      (status.SUCCESS === removeProviderState.status &&
        prevRemoveProviderState !== removeProviderState.status) ||
      (status.SUCCESS === editProviderState.status &&
        prevEditProviderState !== editProviderState.status)
    ) {
      setProvidersQueryString({ ...InitialQueryString });
    }
  }, [submitProvidersBulkState.status, removeProviderState.status, editProviderState.status]);
  useEffect(() => {
    dispatch(fetchProviders(providersQueryString));
  }, [dispatch, providersQueryString]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  const searchBarInputTimeout = useRef(null);
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################

  const handleInputFieldChange = () => {};

  const handleSearchInputChange = (searchTerm, reset) => {
    const queryString = {
      ...providersQueryString,
      pageNumber: 1,
      isShowMore: false,
    };
    if (searchTerm) queryString.searchTerm = searchTerm;
    if (reset) delete queryString.searchTerm;

    setProvidersQueryString(queryString);
  };

  const handleSearchBarInputChange = event => {
    const { value } = event.target;

    if (value.length > 30) return;
    setSearchQuery(value);

    if (searchBarInputTimeout.current) clearTimeout(searchBarInputTimeout.current);

    if (value && value.length >= searchQueryMinLength) {
      searchBarInputTimeout.current = setTimeout(() => {
        clearTimeout(searchBarInputTimeout.current);

        handleSearchInputChange(value);
      }, 500);
    } else if (value.length < searchQueryMinLength && providersQueryString.searchTerm)
      handleSearchInputChange(value, true);
  };

  const handleShowMoreClick = () => {
    const data = {
      ...providersQueryString,
    };
    data.pageNumber += 1;
    data.isShowMore = true;
    setProvidersQueryString(data);
  };

  const handleRemoveProvider = rowDataPayload => {
    const { id, priceListId } = rowDataPayload;
    const payload = {
      id,
      data: {
        priceListId,
      },
    };
    dispatch(removeProvider(payload));
  };

  const handleProviderDeactivate = rowDataPayload => {
    const { id, name, active } = rowDataPayload;
    const payload = {
      id,
      data: {
        priceListId,
        name,
        active: !active,
      },
    };
    dispatch(editProvider(payload));
  };

  const handleDropDownFilterChange = (fieldName, selectedValue) => {
    if (selectedValue) {
      setProvidersQueryString(prevValue => {
        const fieldsObj = { ...prevValue };
        fieldsObj[fieldName] = selectedValue;
        return fieldsObj;
      });
      setFiltersSelected(prevState => ({
        ...prevState,
        [fieldName]: true,
      }));
    } else {
      setProvidersQueryString(prevValue => {
        const fieldsObj = { ...prevValue };
        delete fieldsObj[fieldName];
        return fieldsObj;
      });
      setFiltersSelected(prevState => {
        const tempState = { ...prevState };
        delete tempState[fieldName];
        return tempState;
      });
    }
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <PharmaciesProvidersComponent
      isCreateProviderModalHidden={isCreateProviderModalHidden}
      setIsCreateProviderModalHidden={setIsCreateProviderModalHidden}
      isDoctorInfoModalHidden={isDoctorInfoModalHidden}
      setDoctorInfoModalModalHidden={setDoctorInfoModalModalHidden}
      handleInputFieldChange={handleInputFieldChange}
      filtersSelected={filtersSelected}
      searchQuery={searchQuery}
      handleSearchBarInputChange={handleSearchBarInputChange}
      providersQueryString={providersQueryString}
      handleShowMoreClick={handleShowMoreClick}
      handleRemoveProvider={handleRemoveProvider}
      handleProviderDeactivate={handleProviderDeactivate}
      priceListId={priceListId}
      handleDropDownFilterChange={handleDropDownFilterChange}
    />
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

PharmaciesProvidersContainer.propTypes = {};

PharmaciesProvidersContainer.defaultProps = {};

export default PharmaciesProvidersContainer;
